/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DiskStatus {
    getFixupPrototypeFunction() { return DiskStatus.fixupPrototype; }

    static newInstance(model: Partial<DiskStatus>): DiskStatus {
        let obj = Object.assign(new DiskStatus(), model);
        DiskStatus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DiskStatus>): DiskStatus {
        if (!model) return null;
        return DiskStatus.newInstance(<DiskStatus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DiskStatus) {
        if (!obj) return;

        models.DiskStatus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DiskStatus): boolean {
        Object.setPrototypeOf(obj, DiskStatus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.disk_used === undefined) {
            this.disk_used = 0;
        }
        if (this.disk_free === undefined) {
            this.disk_free = 0;
        }
        if (this.total_disk_space === undefined) {
            this.total_disk_space = 0;
        }
        if (typeof this.status_at === "string") {
            this.status_at = new Date(<string><any>this.status_at);
        }
    }

    /**
     * Indicates if disk monitoring is supported
     */
    enabled: boolean;

    /**
     * Disk metric name
     */
    metric_name: string;

    /**
     * Disk mount path
     */
    path: string;

    /**
     * Used disk space
     */
    disk_used: number;

    /**
     * Free disk space
     */
    disk_free: number;

    /**
     * Total disk space
     */
    total_disk_space: number;

    /**
     * Indicates if disk usage is critical
     */
    is_critical: boolean;

    /**
     * Timestamp of disk status
     */
    status_at: Date;

}
